import { Shield } from 'lucide-react';

export default function Disclaimer() {
  return (
    <div className="page-transition pt-20" data-testid="disclaimer-page">
      <section className="section-padding">
        <div className="container-main">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <div className="inline-flex items-center gap-2 bg-[#E8F5E9] text-[#2E7D32] px-4 py-2 rounded-full text-sm font-medium mb-6">
                <Shield className="w-4 h-4" />
                Legal
              </div>
              <h1 className="text-4xl sm:text-5xl font-bold text-[#1A1C1A] mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
                Disclaimer
              </h1>
              <p className="text-[#52525B]">Last Updated: December 2024</p>
            </div>

            <div className="prose prose-lg max-w-none text-[#52525B]">
              <h2 className="text-2xl font-bold text-[#1A1C1A] mt-8 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>General Disclaimer</h2>
              <p>
                The information provided on the Primes Pick website is for general informational purposes only. While we strive to keep the information accurate and up-to-date, we make no representations or warranties of any kind, express or implied, about the completeness, accuracy, reliability, suitability, or availability of the information, products, services, or related graphics contained on the website.
              </p>

              <h2 className="text-2xl font-bold text-[#1A1C1A] mt-8 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>Professional Advice Disclaimer</h2>
              <p>
                The content on this website is not intended to be a substitute for professional pest control advice, diagnosis, or treatment. Always seek the advice of qualified pest control professionals with any questions you may have regarding a pest infestation or the condition of your property.
              </p>

              <h2 className="text-2xl font-bold text-[#1A1C1A] mt-8 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>Service Results Disclaimer</h2>
              <p>
                Results from pest control treatments may vary depending on various factors including:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Severity of infestation</li>
                <li>Type of pest</li>
                <li>Environmental conditions</li>
                <li>Property conditions and structure</li>
                <li>Customer compliance with preparation and follow-up instructions</li>
              </ul>
              <p className="mt-4">
                We cannot guarantee complete elimination of all pests in all situations, though we strive to provide the most effective treatments available.
              </p>

              <h2 className="text-2xl font-bold text-[#1A1C1A] mt-8 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>Testimonials Disclaimer</h2>
              <p>
                Testimonials and reviews appearing on our website are individual experiences, reflecting real-life experiences of those who have used our services. However, results may vary. Testimonials are not intended to make claims that our services can be used to diagnose, treat, cure, or prevent any condition.
              </p>

              <h2 className="text-2xl font-bold text-[#1A1C1A] mt-8 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>External Links Disclaimer</h2>
              <p>
                Our website may contain links to external websites that are not provided or maintained by Primes Pick. We do not guarantee the accuracy, relevance, timeliness, or completeness of any information on these external websites. The inclusion of any link does not imply endorsement, approval, or control of the linked website or its content.
              </p>

              <h2 className="text-2xl font-bold text-[#1A1C1A] mt-8 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>Pricing Disclaimer</h2>
              <p>
                All prices displayed on our website are subject to change without notice. Final pricing for services will be confirmed during the inspection or consultation process and may vary based on the specific needs of your property.
              </p>

              <h2 className="text-2xl font-bold text-[#1A1C1A] mt-8 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>Product Information Disclaimer</h2>
              <p>
                Information about pest control products and treatments is provided for educational purposes. All products used by Primes Pick are EPA-registered and applied according to label instructions by licensed technicians. Safety information and precautions will be provided before any treatment.
              </p>

              <h2 className="text-2xl font-bold text-[#1A1C1A] mt-8 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>Limitation of Liability</h2>
              <p>
                In no event shall Primes Pick be liable for any special, incidental, indirect, or consequential damages whatsoever arising out of or in connection with your access, use, or inability to use the website or any services purchased through the website.
              </p>

              <h2 className="text-2xl font-bold text-[#1A1C1A] mt-8 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>Changes to This Disclaimer</h2>
              <p>
                We reserve the right to update or change this disclaimer at any time. Any changes will be posted on this page with an updated revision date.
              </p>

              <h2 className="text-2xl font-bold text-[#1A1C1A] mt-8 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>Contact Us</h2>
              <p>If you have any questions about this disclaimer, please contact us:</p>
              <ul className="list-none space-y-2 mt-4">
                <li><strong>Email:</strong> support@primespick.store</li>
                <li><strong>Phone:</strong> +1-888-356-8891</li>
                <li><strong>Address:</strong> 1284 Silver Lake Road, Minneapolis, MN 44401</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
